import { useCallback, useContext, useEffect } from "react";
import { UserContext, UserPayload } from "../../Context/userContext";
import { ISortObj } from "../../Models/applicationModels";
import { useAgentsStore } from "./store/agents.store";

export const useAgentsPage = () => {
    const { setShowLoader, showLoader } = useContext(UserContext) as UserPayload;

    const fetchAllAgents = useAgentsStore((state) => state.fetchAllAgents);
    const setPageIndex = useAgentsStore((state) => state.setPageIndex);
    const setPageSize = useAgentsStore((state) => state.setPageSize);
    const setSearchParam = useAgentsStore((state) => state.setSearchParam);
    const setSortRequest = useAgentsStore((state) => state.setSortRequest);

    useEffect(() => {
        fetchAllAgents({ setShowLoader });
    }, [fetchAllAgents, setShowLoader]);

    const handleChangePage = useCallback(
        async (_event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
            setPageIndex(newPage + 1);
            await useAgentsStore.getState().fetchAllAgents({
                setShowLoader,
                force: true,
            });
        },
        [setPageIndex, setShowLoader]
    );

    const handleChangePageSize = useCallback(
        async (event: React.ChangeEvent<HTMLInputElement>) => {
            setPageSize(Number(event.target.value));
            await useAgentsStore.getState().fetchAllAgents({
                setShowLoader,
                force: true,
            });
        },
        [setPageSize, setShowLoader]
    );

    const handleSearch = useCallback(
        async (value: string) => {
            const nextSearchParam = value || null;
            const currentSearchParam = useAgentsStore.getState().searchParam;

            if (nextSearchParam === currentSearchParam || showLoader) {
                return;
            }

            setSearchParam(nextSearchParam);
            await useAgentsStore.getState().fetchAllAgents({
                setShowLoader,
                force: true,
            });
        },
        [setSearchParam, setShowLoader, showLoader]
    );

    const handleSortChange = useCallback(
        async (sortItem: ISortObj | null) => {
            setSortRequest(sortItem);
            await useAgentsStore.getState().fetchAllAgents({
                setShowLoader,
                force: true,
            });
        },
        [setSortRequest, setShowLoader]
    );

    return {
        handleChangePage,
        handleChangePageSize,
        handleSearch,
        handleSortChange,
    };
};
